export class NewContactData{
    public name: string;
    public email: string;
    public phone: string;
    public s_ins: number;
    public s_cont: number;
    public cix: number;
    public opc: number;
    public token: string;

    constructor(){
    this.name = '';
    this.email = '';
    this.phone = '';
    this.s_ins = null;
    this.s_cont = null;
    this.cix = null;
    this.opc = null;
    this.token = '';
    }
}